"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var icon_svg_1 = __importDefault(require("./icon.svg"));
var LoaderWrapperStyles = function (props) { return ({
    position: props.relativeAlign ? 'relative' : 'absolute',
    top: props.relativeAlign ? 'initial' : 169,
    height: '-webkit-fill-available',
    background: props.theme.colors.grey.pastel,
    opacity: 0.9,
    zIndex: 10000000000,
    width: '-webkit-fill-available',
    justifyContent: 'space-around',
}); };
var LoaderWrapper = styled_components_1["default"](box_1["default"])(LoaderWrapperStyles);
var TextWrapperStyles = function (props) { return ({
    flexDirection: 'column',
    textAlign: 'center',
    transform: props.relativeAlign ? 'translateY(0px)' : 'translateY(210px)',
    rowGap: 21,
    alignItems: 'center',
}); };
var TextWrapper = styled_components_1["default"](box_1["default"])(TextWrapperStyles);
var RHSLoader = function (_a) {
    var text = _a.text, relativeAlign = _a.relativeAlign;
    return (react_1["default"].createElement(LoaderWrapper, { relativeAlign: relativeAlign },
        react_1["default"].createElement(TextWrapper, { relativeAlign: relativeAlign },
            react_1["default"].createElement(icon_1["default"], { src: icon_svg_1["default"] }),
            react_1["default"].createElement(text_1["default"], null, text))));
};
exports["default"] = RHSLoader;
